export const environment = {
  production: true,
  buildEnv: 'prod',
  baseUrl: 'https://app-api.kingiftcard.com/api/v1',
  baseUrlV2: 'https://app-api.kingiftcard.com/api/v2',
  defaultLang: 'en',
  SENTRY_ENVIRONMENT: 'production',
  // storeId: 'e54c9c8f-5e83-4940-8c0c-b2134468bbbb',
  clientId: '407565715316-cf1i0jpa0702nv3lc0nb9io7mg8cno67.apps.googleusercontent.com',
  appleClientId: '42K6N3L295.com.kingiftcard',
  userAccountBaseUrl: 'https://apiaccount.rhinobit.net/api/v1',
  gateIoBaseUrl: 'https://openplatform.gateapi.io',
  gateIoClientID: `FQqrhxfxTvVUCuER`,
  API_KEY: 'c7546d31-870c-4a1b-801f-b0423d2004c3',
  globalID: 254,
  firebaseConfig: {
    appId: '1:407565715316:web:7a8f7071384a69bd4c8e21',
    gtmId: 'GTM-WRH43QJL',
    apiKey: 'AIzaSyBFLOWht2szTWI1lOfDp6ZrMQyTo0zz2zY',
    projectId: 'kingiftcard',
    // authDomain: 'kingiftcard.com',
    authDomain: 'kingiftcard.firebaseapp.com',
    measurementId: 'G-WNBGE9ZM05',
    storageBucket: 'kingiftcard.firebasestorage.app',
    messagingSenderId: '407565715316',
  },
};
